import client from "lib/apolloClient/client";
import { attachmentGroupsNodeFragment } from "modules/CommonFragments";

export const getAttachmentGroupsOfNodeFromCache = ({ id }) => {
  try {
    const fragment =
      attachmentGroupsNodeFragment[
        "studentAssignmentSubmissionAttachmentGroups"
      ];

    return client.readFragment({
      id: `StudentAssignmentSubmission:${id}`,
      fragment: fragment,
      fragmentName: "studentAssignmentSubmissionAttachmentGroupsItem",
    });
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const writeAttachmentGroupsOfNodeInCache = ({ id, data }) => {
  try {
    const fragment =
      attachmentGroupsNodeFragment[
        "studentAssignmentSubmissionAttachmentGroups"
      ];

    client.writeFragment({
      id: `StudentAssignmentSubmission:${id}`,
      fragment: fragment,
      fragmentName: "studentAssignmentSubmissionAttachmentGroupsItem",
      data,
    });
  } catch (e) {
    console.error(e);
  }
};
